var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-screen grid grid-cols-layout bg-gray-100"},[_c('Sidebar'),_c('div',{staticClass:"w-full max-h-screen overflow-y-auto"},[_c('Header'),_c('div',{staticClass:"w-full h-[calc(100%-72px)] py-[14px] px-6"},[_vm._t("default")],2)],1),_c('ResetPassword')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }